import { getFullUrl } from '../api.config';

export const ENDPOINTS = {
    LOGIN:"/authservice/auth/login"
} as const;

export const getAuthUrl = (endpoint: string) => getFullUrl(endpoint);